import {
   Component,
   ViewChild,
   AfterViewInit,
   OnDestroy,
   PLATFORM_ID,
   Inject,
} from '@angular/core';
import { OnboardingService } from './features/onboarding/services/onboarding.service';
import {
   NavigationEnd,
   NavigationStart,
   NavigationError,
   Params,
   Router,
   Event,
} from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService } from './shared/services/auth.service';

import { ApiService } from './shared/services/api.service';

import { Token } from '@angular/compiler';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { first, lastValueFrom, map, Subject, subscribeOn } from 'rxjs';
import { LoaderServices } from 'src/app/shared/services/loader.service';
import { FirebaseCloudFunctionsService } from 'src/app/shared/services/firebase-cloud-functions.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FirebaseRemoteConfigService } from './shared/services/firebase-remote-config.service';
import { UserApiService } from './shared/services/user-api.service';
import { SubscriptionService } from './shared/services/subscription.service';
import { Role, SubscriptionInfoModel } from './models/subscription-info.model';
import { ToastrService } from 'ngx-toastr';
import { DownloadPromptComponent } from './shared/components/download-prompt/download-prompt.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PremiumMemberGreetingPopupComponent } from './shared/components/premium-member-greeting-popup/premium-member-greeting-popup.component';
import { AnalyticsUtils } from 'src/app/shared/services/analytics-utils';
import { DataLayerService } from './shared/services/data-layer.service';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared/services/shared.service';
import { MusaffaRedirectService } from './shared/services/musaffa-redirect.service';
import { CouponService } from './shared/services/coupon.service';
import { PricingService } from './features/pricing/services/pricing.service';
import { setCountryCode } from './stores/global/global.actions';
import { distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { loadWatchlistSymbols } from './stores/watchlist-symbols/watchlist-symbols.actions';
import { loadPermissions } from './stores/access-control/access-control.actions';
import { PermissionsState } from './stores/access-control/access-control.reducers';
import { isPlatformBrowser } from '@angular/common';
// import { QuestionnaireModalComponent } from './cabinet/questionnaire-modal/questionnaire-modal.component';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { ReferrerTrackingService } from './shared/services/referrer-tracking.service';
import { RibaModalService } from './shared/services/riba-modal.service';
import { collapseSidebar, hideSidebar } from './stores/sidebar/sidebar.actions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit, OnDestroy {
   private unsubscribe$: Subject<void> = new Subject<void>();
   title = 'musaffa-platform';
   fireAuthUserLoaded = false;
   loadingPermissions = true;
   bannerText = '';
   bannerLinkText = '';
   bannerLink = '';
   showBanner = false;
   stripeSubscriptionStatus: any;
   record_id: string | null = '';
   module: string | null = '';
   @ViewChild(DownloadPromptComponent) prompt!: DownloadPromptComponent;
   userNewRole: Role = null;
   isSubscribed = false;
   isUnderMaintenance = false;
   isBrowser = false;
   isOnboardingQuestionairOpen = false;
   isStickySignupBannerVisible = false;
   isHandset = false;
   private hasNavigationEnded = false;


   private popupExcludedPages: string[] = [
      '/stock/',
      '/etf/',
      '/supported-countries', 
      '/supported-brokerages',
      '/investing-coverage',
   ];

   private stickySignupBannerExcludedPages: string[] = [
      '/authentication/',
      '/supported-countries',
      '/supported-brokerages',
      '/investing-coverage',
   ];


   constructor(
      private router: Router,
      private apiService: ApiService,
      public auth: AuthService,
      public subscriptionService: SubscriptionService,
      private toaster: ToastrService,
      private route: ActivatedRoute,
      private modalService: NgbModal,
      // public authFire: AngularFireAuth,
      private firebaseConfigService: FirebaseRemoteConfigService,
      public userApiService: UserApiService,
      private analyticsUtils: AnalyticsUtils,
      private activatedRoute: ActivatedRoute,
      private dataLayerService: DataLayerService,
      private sharedService: SharedService,
      private musaffaRedirectService: MusaffaRedirectService,
      private couponService: CouponService,
      private permissionStore: Store<{ permissions: PermissionsState }>,
      private store: Store,
      private titleService: Title,
      private metaService: Meta,
      private referrerTrackingService: ReferrerTrackingService,
      private ribaModalService: RibaModalService,
      private onboardingService: OnboardingService,
      private pricingService: PricingService,
      private breakpointObserver: BreakpointObserver,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
      if (this.isBrowser) {
         this.breakpointObserver.observe(['(max-width: 767px)'])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(result => {
               this.isHandset = result.matches;
               this.updateStickySignupBannerVisibility();
            });
      }

      if (!this.isBrowser) {
         const log = (window as any).ssrLog || console.error;
         log('AppComponent: constructor running for URL: ' + this.router.url);
      }

      // this.isUnderMaintenance = true;
      // this.permissionStore
      //    .select(({ permissions }) => permissions.loading)
      //    .subscribe((isPermissionLoading) => {
      //       if(isPermissionLoading) {
      //          this.loadingPermissions = true;
      //          console.error('loadingPermissions', isPermissionLoading);
      //       } else {
      //          this.loadingPermissions = false;
      //          console.error('loadingPermissions', this.loadingPermissions);
      //       }
      //    });
      //    SubscriptionService.userSubscriptionFetched.subscribe((isUserSubscriptionFetched) => {
      //       if(isUserSubscriptionFetched) {
      //          this.store.dispatch(loadPermissions());
      //       }
      //    });
      if (this.isBrowser) {
         // this.auth.isLoggedIn$.pipe(
         //    takeUntil(this.unsubscribe$),
         //    distinctUntilChanged(),
         //    filter(isLoggedIn => isLoggedIn),
         //    switchMap(() => this.onboardingService.fetchActivationConfig())
         // ).subscribe();
         this.couponService.extractAndStoreCoupon();
         var instance = this;
         import('branch-sdk').then((branch) => {
            branch.data(function (err, data) {
               var branchData: any = data;
               var module = branchData?.data_parsed?.$deeplink_path;
               var record_id = branchData?.data_parsed?.record_id;

               instance.musaffaRedirectService.goToPage(module, record_id);
            });
         });
         const url = new URL(window.location.href);
         const params = new URLSearchParams(url.search);

         this.module = params.get('module');
         this.record_id = params.get('record_id');
      }

      this.subscriptionService.setUserSubscriptionInfo().then(() => {
         this.store.dispatch(loadPermissions());
      });

      router.events.subscribe((val) => {
         if (!isPlatformBrowser(this.platformId)) {
            const log = (window as any).ssrLog || console.error;
            let msg = 'AppComponent: router event: ' + val.constructor.name;
            if (val instanceof NavigationEnd) msg += ' - url: ' + val.urlAfterRedirects;
            if (val instanceof NavigationError) msg += ' - error: ' + val.error;
            log(msg);
         }
         if (!isPlatformBrowser(this.platformId)) return;
         if (this.bannerText) this.updateBannerVisibility();
         if (val instanceof NavigationStart) {
            this.hasNavigationEnded = false;
            // Set title and description for SEO only for pages that don't have specific metadata
            if (!val.url.includes('/stock-screener') && !val.url.includes('/etf-screener') && !val.url.includes('/halal-collection')) {
               this.titleService.setTitle('Musaffa - Halal Stock Screening & Investment Platform');
               this.metaService.updateTag({
                 name: 'description',
                 content: 'Musaffa is your trusted platform for halal stock screening. Find Shariah-compliant stocks and ETFs with our comprehensive screening tools.'
               });
            }
            this.subscriptionService.setUserSubscriptionInfo().then(() => {
               this.store.dispatch(loadPermissions());
            });
            // const countryCode = localStorage.getItem('countryCode');
            // if (!countryCode) {
            //    this.apiService.getUserCountryCode().then((response) => {
            //       if (response?.data?.iso_code)
            //          localStorage.setItem(
            //             'countryCode',
            //             response.data.iso_code
            //          );
            //    });
            // }
         }
         if (val instanceof NavigationEnd) {
            this.hasNavigationEnded = true;
            this.subscriptionService.setSubscriptionPlans();
            this.analyticsUtils.identifyUser();

            if (
               !(
                  val.url.includes('authentication') ||
                  val.url.includes('pages')
               )
            ) {
               localStorage.setItem('redirectUrl', val.url);
            }
            if (
               !val.url.includes('/stock-screener') &&
               !val.url.includes('/etf-screener') &&
               !val.url.includes('/halal-collection')
            ) {
               if (isPlatformBrowser(this.platformId)) {
                  setTimeout(() => {
                     window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'instant' as ScrollBehavior,
                     });
                  }, 100);
               }
            }

            // Show riba modal on all pages except stock and ETF pages
            this.checkAndShowRibaModal(val.url);

            if (this.isBrowser) {
               this.updateStickySignupBannerVisibility();
            }
         }
      });

      if (this.module) {
         this.musaffaRedirectService.goToPage(this.module, this.record_id);
      }

      
   }

   shouldHideStickySignupBanner(): boolean {
      return this.stickySignupBannerExcludedPages.some((path) =>
         this.router.url.includes(path)
      );
   }

   isMobile(): boolean {
      return this.isHandset;
   }

   onStickySignupClick(): void {
      this.auth.setSignupSource('Signup Bottom Sticky CTA');
   }


   updateStickySignupBannerVisibility(): void {
      this.isStickySignupBannerVisible =
         !this.auth.isLoggedIn() &&
         !this.shouldHideStickySignupBanner() &&
         this.isMobile();
   }




   // checkAndOpenDownloadPrompt() {
   //    if (this.isBrowser) {
   //       const hasOpenedPrompt = sessionStorage.getItem('hasOpenedPrompt');
   //       if (this.isSubscribed && !hasOpenedPrompt) {
   //          this.openPrompt();
   //          sessionStorage.setItem('hasOpenedPrompt', 'true');
   //       }
   //    }
   // }

   ngAfterViewInit(): void {
      // this.checkAndOpenDownloadPrompt();
   }

   ngOnDestroy() {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
   }

   private async setCountryCodeIfNeeded(): Promise<void> {
      // Seed the store immediately with whatever is already in localStorage
      const cachedCode = localStorage.getItem('countryCode');
      if (cachedCode) {
         this.store.dispatch(setCountryCode({ countryCode: cachedCode }));
         return; // 🚀 User requested: Only fetch if NOT in localStorage
      }

      try {
         const response = await this.apiService.getUserCountryCode();
         const newCode = response?.data?.iso_code;
         if (newCode) {
            localStorage.setItem('countryCode', newCode);
            // Always keep the store up to date
            this.store.dispatch(setCountryCode({ countryCode: newCode }));
         }
      } catch (err) {
         console.error('Failed to fetch country code', err);
      }
   }

   openPrompt() {
      this.prompt.openDownloadPrompt();
   }

   shouldHideBanner() {
      const inValidRoutes: string[] = [
         '/pages/stripe-membership-main',
         '/pages/stripe-premium-mobile',
         '/authentication/form',
         '/authentication/registration',
         '/authentication/sso-login',
         '/authentication/login',
      ];
      return (
         this.auth.checkRole('PREMIUM') ||
         inValidRoutes.includes(this.router.url)
      );
   }
   updateBannerVisibility() {
      if (this.shouldHideBanner()) {
         this.showBanner = false;
      } else {
         this.showBanner = true;
      }
   }

   // async logoutFireAuthAndSignInAnonymously() {
   //    var fireUser = await lastValueFrom(this.authFire.authState.pipe(first()));
   //    if (!fireUser || fireUser?.isAnonymous == false) {
   //       const auth = getAuth();
   //       await signInAnonymously(auth);
   //    }
   // }

   private async setOnboardingInfo() {
      // this.modalService.open(QuestionnaireModalComponent, {
      //    modalDialogClass: 'paywall-popup-modal',
      //    centered: true,
      //    scrollable: true,
      //    backdrop: 'static',
      //    size: 'lg',
      // });
      const response: any = await this.apiService.getOnboardingInfo();
      const onboardingInfo = response?.data;
      if (onboardingInfo) {
         let skippedAt = onboardingInfo.onboarding_skipped_at;
         let completedAt = onboardingInfo.onboarding_completed_at;
         let onboarding_skip_count = onboardingInfo.onboarding_skip_count;
         if (!completedAt && onboarding_skip_count < 3) {
            if (skippedAt) {
               const thirtyDaysAgo = new Date();
               thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 7);
               const skippedDate = new Date(skippedAt);
               if (skippedDate < thirtyDaysAgo) {
                  skippedAt = null;
               }
            }
            if (!skippedAt) {
               this.openOnboardingQuestionair();
            }
         }
      }
   }

   openOnboardingQuestionair() {
      if (!this.hasNavigationEnded) return;

      if (this.router.url.startsWith('/pricing')) return;

      if (this.isOnboardingQuestionairOpen) return;

      this.isOnboardingQuestionairOpen = true;

      // this.modalService.open(QuestionnaireModalComponent, {
      //    modalDialogClass: 'questionnaire-popup-modal',
      //    windowClass: 'questionnaire-popup-modal-window',
      //    centered: true,
      //    scrollable: true,
      //    backdrop: 'static',
      //    size: 'lg',
      // });
   }

   async ngOnInit(): Promise<void> {
      if (this.isBrowser) {
         await this.setCountryCodeIfNeeded();
         this.updateStickySignupBannerVisibility();
      }
     
      SubscriptionService.subscriptionData
         .pipe(takeUntil(this.unsubscribe$))
         .subscribe((data: SubscriptionInfoModel) => {
            this.userNewRole = data.newRole;
            this.isSubscribed = data.isSubscribed;
            // this.checkAndOpenDownloadPrompt();
         });
      this.route.queryParams
         .pipe(takeUntil(this.unsubscribe$))
         .subscribe((params) => {
            if (params['onboarding_questions'] === 'true') {
               // if (!this.auth.isLoggedIn()) {
               //    this.auth.openAuthPopup();
               // } else {
                  // this.openOnboardingQuestionair();
               // }
            } else {
               if (this.auth.getUserId()) {
                  // this.setOnboardingInfo();
               }
            }
         });
         if (this.auth.getUserId()) {
            this.store.dispatch(loadWatchlistSymbols());
         }
         

      this.fireAuthUserLoaded = true;

      this.updateBannerText();

      this.auth.roleUpdatedEvent.subscribe((dt) => {
         this.updateBannerText();
         if (this.isBrowser) {
            this.updateStickySignupBannerVisibility();
         }
      });

      this.route.queryParams.subscribe(async (params) => {
         this.analyticsUtils.identifyUser();
         this.stripeSubscriptionStatus = params?.subscription_status;
         const duration = params?.duration ?? '';
         if (this.stripeSubscriptionStatus != undefined) {
            if (this.stripeSubscriptionStatus === 'success') {
               this.modalService.open(PremiumMemberGreetingPopupComponent, {
                  centered: true,
                  backdrop: 'static',
               });
               await this.analyticsUtils.user_subscription_completed(
                  duration ?? ''
               );
               this.dataLayerService.userSubscriptionCompletedEvent(duration);
            } else if (this.stripeSubscriptionStatus === 'cancel') {
               this.toaster.error('Subscription was not completed!');
               this.analyticsUtils.user_subscription_failed('Cancelled');
            }
            const queryParams: Params = {
               subscription_status: null,
               duration: null,
            };
            this.router.navigate([], {
               relativeTo: this.activatedRoute,
               queryParams,
               replaceUrl: true,
               queryParamsHandling: 'merge',
            });
         }
      });
   }

   async updateBannerText() {
      if (!isPlatformBrowser(this.platformId)) return;
      var config = await this.firebaseConfigService.getConfigDefault();
      this.showBanner = !this.shouldHideBanner();

      if (this.auth.checkRole('ANONYMOUS')) {
         this.bannerText = config['web_desktop_anonymous_banner_text'];
         this.bannerLinkText = config['web_desktop_anonymous_banner_link_text'];
         this.bannerLink = this.getAnonymousBannerLink();
      } else if (this.auth.checkRole('FREEMIUM')) {
         this.bannerText = config['web_desktop_freemium_banner_text'];
         this.bannerLinkText = config['web_desktop_freemium_banner_link_text'];
         this.bannerLink = this.getFreemiumBannerLink();
      }

      this.updateBannerVisibility();
   }

   getAnonymousBannerText() {
      return 'We are giving out 3-months of Premium for free!';
   }

   getFreemiumBannerText() {
      return 'We are giving out 3-months of Premium for free!';
   }

   getAnonymousBannerLinkText() {
      return 'Click to claim this offer';
   }

   getFreemiumBannerLinkText() {
      return 'We are giving out 3-months of Premium for free!';
   }

   getAnonymousBannerLink() {
      return isPlatformBrowser(this.platformId)
         ? window.location.origin + '/authentication/registration'
         : '/authentication/registration';
   }

   getFreemiumBannerLink() {
      return isPlatformBrowser(this.platformId)
         ? window.location.origin + '/pages/stripe-premium-mobile'
         : '/pages/stripe-premium-mobile';
   }

   private checkAndShowRibaModal(url: string): void {
      if (!this.isBrowser) return;
    
      // Check if user has already seen the modal in this session
      const hasSeenRibaModal = sessionStorage.getItem('hasSeenRibaModal');
      if (hasSeenRibaModal) return;
    
      // Check if the current URL matches any of the excluded paths
      const shouldExclude = this.popupExcludedPages.some(path => url.includes(path));
      if (shouldExclude) return;
    
      // Otherwise, show the modal
      this.ribaModalService.openModal();
      sessionStorage.setItem('hasSeenRibaModal', 'true');
   }
}
